module.exports = __webpack_public_path__ + "static/media/aa11.39a01828.jpg";